function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 49h19.4M46 49l10 .046c-.343-3.771-.55-10.61-1.308-11.583C51 34 41.131 22.792 35.498 21c-6.327-.064-28.024.032-35.5 0v27.94l2.8.06m19.047-25.454h13.296C37 24.046 44.92 31.023 48 35l-26.153.046z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -996.36)",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.647,
  cy: 1046.5,
  rx: 5.911,
  ry: 5.64
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.647,
  cy: 1046.5,
  rx: 2.834,
  ry: 2.704
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 40.174,
  cy: 1046.5,
  rx: 5.911,
  ry: 5.64
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 40.174,
  cy: 1046.5,
  rx: 2.834,
  ry: 2.704
})), /*#__PURE__*/React.createElement("path", {
  d: "M21.818 37.54h3.71"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.7 37.74h4.6c1.027 0 1.3 3 1.3 3-3.664.135-4.6 0-5.9-3z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var SvgVan = function SvgVan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Van.108cb53c.svg";
export { ForwardRef as ReactComponent };